import React from "react";
import { Link } from "react-router-dom";
import {
  ShoppingCart,
  Image,
  Plus,
  Grid3X3,
  Shapes,
  Users,
} from "lucide-react";

const dashboardItems = [
  { to: "/orders", label: "Orders", icon: ShoppingCart, color: "bg-blue-500" },
  { to: "/banner", label: "Banner", icon: Image, color: "bg-pink-500" },
  {
    to: "/addproduct",
    label: "Add Product",
    icon: Plus,
    color: "bg-green-500",
  },
  {
    to: "/categories",
    label: "Categories",
    icon: Grid3X3,
    color: "bg-purple-500",
  },
  {
    to: "/dieshapes",
    label: "Die Shapes",
    icon: Shapes,
    color: "bg-orange-500",
  },
  { to: "/users", label: "Users", icon: Users, color: "bg-indigo-500" },
];

const Dashboard = () => {
  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-800">VyapakPrint Admin</h1>
        <p className="text-gray-500 mt-1">
          Manage orders, products, banners and users from here
        </p>
      </div>

      {/* Cards */}
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {dashboardItems.map((item, index) => {
          const Icon = item.icon;
          return (
            <Link
              key={index}
              to={item.to}
              className="group bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 p-6 flex flex-col items-center justify-center text-center hover:-translate-y-1"
            >
              {/* Icon Circle */}
              <div
                className={`${item.color} w-14 h-14 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`}
              >
                <Icon className="text-white w-7 h-7" />
              </div>

              {/* Title */}
              <h3 className="text-lg font-semibold text-gray-800">
                {item.label}
              </h3>

              <p className="text-sm text-gray-500 mt-1">Open {item.label}</p>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default Dashboard;
